import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { memberService, tagService } from '../services/api';
import locationService from '../services/locationService';
import axios from 'axios';
import './TagPage.css';

const TagPage = () => {
  const { tagId } = useParams();
  // const navigate = useNavigate();
  const [tag, setTag] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true); // Para controlar el mensaje inicial
  const [formData, setFormData] = useState({
    nombrePropietario: '',
    apellidoPropietario: '',
    nombreMascota: '',
    telefono: '',
    direccion: '',
    email: '',
    tieneWhatsapp: true,
  });
  const [submissionStatus, setSubmissionStatus] = useState(null); // 'success', 'error'
  const [isGettingLocation, setIsGettingLocation] = useState(false);


  // Configuración de axios para llamadas públicas (sin autenticación)
  // const publicApi = axios.create({
  //   baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  // });

  // Función para obtener tag sin autenticación
  const getPublicTag = async (id) => {
    try {
      // Crear una instancia temporal de axios sin interceptores
      const tempAxios = axios.create({
        baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      // Usar el endpoint público directo
      const response = await tempAxios.get(`/tags/${id}`);
      return response.data;
    } catch (error) {
      console.error('Public API error:', error);
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  };

  // Effect para cambiar el título de la página dinámicamente
  useEffect(() => {
    if (tag) {
      if (tag.activo) {
        document.title = 'Mascotag';
      } else {
        document.title = 'Mascotag - Registro';
      }
    }
  }, [tag]);

  useEffect(() => {
    const fetchTagData = async () => {
      console.log('Fetching tag with ID:', tagId);
      try {
        // Verificar si hay token disponible
        const token = localStorage.getItem('token');
        
        let fetchedTag;
        if (token) {
          // Si hay token, usar la API autenticada
          console.log('Using authenticated API');
          fetchedTag = await tagService.getTagById(tagId);
        } else {
          // Si no hay token, usar la API pública
          console.log('No token found, using public API');
          fetchedTag = await getPublicTag(tagId);
          console.log('Tag fetched with public API:', fetchedTag);
        }
        
        console.log('Tag fetched successfully:', fetchedTag);
        setTag(fetchedTag);
        if (fetchedTag && fetchedTag.activo) {
          setFormData({
            nombrePropietario: fetchedTag.nombrePropietario || '',
            apellidoPropietario: fetchedTag.apellidoPropietario || '',
            nombreMascota: fetchedTag.nombreMascota || '',
            telefono: fetchedTag.telefono || '',
            direccion: fetchedTag.direccion || '',
            email: fetchedTag.email || '',
            tieneWhatsapp: fetchedTag.tieneWhatsapp || false,
          });
        }
        setIsInitialLoad(false); // Marcar que ya no es la carga inicial
      } catch (error) {
        console.error(`Error fetching tag ${tagId}:`, error);
        console.error('Error response:', error.response);
        setLoading(false);
        // Mostrar un mensaje de error más específico
        if (error.response?.status === 404) {
          setTag(null); // Esto mostrará "Tag no encontrado"
        } else {
          console.error('Error details:', error.response?.data || error.message);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchTagData();
  }, [tagId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  // Función para formatear número de teléfono
  const formatPhoneNumber = (phone) => {
    if (!phone) return '';
    
    // Convertir a string y limpiar
    let clean = phone.toString().replace(/\D/g, '');
    
    // Si empieza con 0, removerlo
    if (clean.startsWith('0')) {
      clean = clean.substring(1);
    }
    
    // Si no tiene código de país y tiene al menos 8 dígitos, agregar +54
    if (!clean.startsWith('54') && clean.length >= 8) {
      clean = '54' + clean;
    }
    
    return clean;
  };


  // Función para manejar WhatsApp SIN ubicación
  const handleWhatsAppClickSimple = (e) => {
    e.preventDefault();
    
    // Crear mensaje simple sin ubicación
    const mensaje = `Hola! Encontré a ${tag.nombreMascota}`;
    
    // Crear enlace final
    const telefonoFormateado = formatPhoneNumber(tag.telefono);
    
    // Detectar dispositivo específico para usar el esquema correcto
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    
    let whatsappLink;
    if (isIOS) {
      // En iOS usar wa.me que funciona mejor
      whatsappLink = `https://wa.me/${telefonoFormateado}?text=${encodeURIComponent(mensaje)}`;
    } else if (isAndroid) {
      // En Android usar esquema directo
      whatsappLink = `whatsapp://send?phone=${telefonoFormateado}&text=${encodeURIComponent(mensaje)}`;
        } else {
      // En escritorio usar web.whatsapp.com
      whatsappLink = `https://web.whatsapp.com/send?phone=${telefonoFormateado}&text=${encodeURIComponent(mensaje)}`;
    }
    
    // Abrir WhatsApp según el dispositivo
    if (isIOS) {
      // En iOS usar window.location.href que es más confiable
      try {
        window.location.href = whatsappLink;
      } catch (error) {
        // Fallback: intentar con window.open
        window.open(whatsappLink, '_blank');
      }
    } else if (isAndroid) {
      // En Android intentar abrir la app directamente
      window.location.href = whatsappLink;
    } else {
      // En escritorio abrir en nueva ventana/pestaña
      window.open(whatsappLink, '_blank');
    }
  };

  // Función simplificada para manejar WhatsApp con ubicación
  const handleWhatsAppClick = async (e) => {
    e.preventDefault();
    setIsGettingLocation(true);
    try {
      // Solicitar ubicación directamente usando el nuevo servicio simplificado
      const locationData = await locationService.requestLocationForContact();
      
      // Crear mensaje con dirección completa y enlace de Google Maps
      const mensaje = `Hola! Encontré a ${tag.nombreMascota} en la dirección: ${locationData.address}\n\nVer ubicación en Google Maps: ${locationData.mapsLink}`;
      
      // Crear enlace final
      const telefonoFormateado = formatPhoneNumber(tag.telefono);
      
      // Detectar dispositivo específico para usar el esquema correcto
      const userAgent = navigator.userAgent;
      const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
      const isAndroid = /Android/i.test(userAgent);
      
      let whatsappLink;
      if (isIOS) {
        // En iOS usar wa.me que funciona mejor, con fallback a whatsapp://
        whatsappLink = `https://wa.me/${telefonoFormateado}?text=${encodeURIComponent(mensaje)}`;
      } else if (isAndroid) {
        // En Android usar esquema directo
        whatsappLink = `whatsapp://send?phone=${telefonoFormateado}&text=${encodeURIComponent(mensaje)}`;
      } else {
        // En escritorio usar web.whatsapp.com
        whatsappLink = `https://web.whatsapp.com/send?phone=${telefonoFormateado}&text=${encodeURIComponent(mensaje)}`;
      }
      
      // Abrir WhatsApp según el dispositivo
      if (isIOS) {
        // En iOS usar window.location.href que es más confiable
        try {
          window.location.href = whatsappLink;
        } catch (error) {
          // Fallback: intentar con window.open
          window.open(whatsappLink, '_blank');
        }
      } else if (isAndroid) {
        // En Android intentar abrir la app directamente
        window.location.href = whatsappLink;
      } else {
        // En escritorio abrir en nueva ventana/pestaña
        window.open(whatsappLink, '_blank');
      }
      
    } catch (error) {
      console.error('Error obteniendo ubicación:', error);
      
      // Mostrar mensaje de error específico con guía
      if (error === 'PERMISSION_DENIED') {
        const guide = locationService.getMobilePermissionGuide();
        alert(`${guide.title}\n\n${guide.steps.join('\n')}\n\nDespués de seguir estos pasos, vuelve a intentar.`);
      } else if (error === 'TIMEOUT') {
        alert('Tiempo de espera agotado al obtener la ubicación. Por favor, intenta nuevamente.');
      } else if (error === 'POSITION_UNAVAILABLE') {
        alert('No se pudo obtener tu ubicación. Verifica que tengas conexión a internet y vuelve a intentar.');
      } else {
        alert(`Error al obtener la ubicación: ${error}`);
      }
    } finally {
      setIsGettingLocation(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validar solo los campos de texto, excluyendo booleanos
    const textFields = {
      nombrePropietario: formData.nombrePropietario,
      apellidoPropietario: formData.apellidoPropietario,
      nombreMascota: formData.nombreMascota,
      telefono: formData.telefono,
      direccion: formData.direccion,
      email: formData.email,
    };

    if (Object.values(textFields).some(value => value.trim() === '')) {
      setSubmissionStatus('error');
      return;
    }

    try {
      console.log('Enviando datos:', formData); // Debug: ver qué se está enviando
      await memberService.registerMember(tagId, formData);
      setSubmissionStatus('success');
      // After successful registration, re-fetch tag data to update the view to read-only
      const token = localStorage.getItem('token');
      const updatedTag = token ? await tagService.getTagById(tagId) : await getPublicTag(tagId);
      console.log('Tag actualizado:', updatedTag); // Debug: ver qué se recibe
      setTag(updatedTag);
      // No cambiar isInitialLoad aquí, mantenerlo en false
      setTimeout(() => {
        setSubmissionStatus(null);
      }, 2000);
    } catch (error) {
      console.error('Error registering member:', error);
      setSubmissionStatus('error');
    }
  };

  if (loading) {
    return <div className="loading-container">Cargando formulario...</div>;
  }

  if (!tag) {
    return <div className="error-container">Tag no encontrado o inválido.</div>;
  }

  // Si es acceso público pero no se pudo obtener el tag
  if (tag.publicAccess) {
    return (
      <div className="tag-registration-page-container">
        <h2>Acceso al Tag: {tagId}</h2>
        <div className="access-message">
          <p>{tag.message}</p>
          <p>Para acceder a este tag, debe estar autenticado como administrador.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tag-registration-page-container">

      {tag.activo ? (
        <div className="read-only-data">
          <h3>
            <img 
              src={require('../images/huellitanegra.jpg')} 
              alt="" 
              width="32" 
              height="32" 
              style={{marginRight: '8px', verticalAlign: 'middle'}}
            />
            Hola! Soy {tag.nombreMascota}
          </h3>
          {/* <p><strong>Mi nombre es:</strong> {tag.nombreMascota}</p> */}
          <p><strong>Mi familiar es:</strong> {tag.nombrePropietario} {tag.apellidoPropietario}</p>
          <p><strong>Telefono:</strong> {tag.telefono}</p>
          <p><strong>Dirección:</strong> {tag.direccion}</p>
          <p><strong>Email:</strong> {tag.email}</p>
          
          
          {(tag.tieneWhatsapp === true || tag.tieneWhatsapp === 'true' || tag.tieneWhatsapp === 1) && (
            <div style={{textAlign: 'center', margin: '20px 0'}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: '10px', padding: '0 20px'}}>
                <button 
                  onClick={handleWhatsAppClick}
                  className="whatsapp-button"
                  disabled={isGettingLocation}
                  style={{
                    width: window.innerWidth <= 768 ? '85%' : '100%', // 85% en mobile con padding, 100% en desktop
                    maxWidth: '500px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px'
                  }}
                >
                <svg width={window.innerWidth <= 768 ? '24' : '22'} height={window.innerWidth <= 768 ? '24' : '22'} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" style={{marginRight: '4px'}}>
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
                <span style={{flex: 1, textAlign: 'center'}}>{isGettingLocation ? 'Obteniendo ubicación...' : 'Compartir ubicación'}</span>
                <div style={{width: window.innerWidth <= 768 ? '24' : '22', height: window.innerWidth <= 768 ? '24' : '22'}}></div>
                </button>
                
                {/* Segundo botón - Contactar sin ubicación */}
                <button 
                  onClick={handleWhatsAppClickSimple}
                  className="whatsapp-button"
                  style={{
                    width: window.innerWidth <= 768 ? '85%' : '100%',
                    maxWidth: '500px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '8px',
                    backgroundColor: '#25D366',
                    opacity: '0.8'
                  }}
                >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="white" style={{marginRight: '8px'}}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                <span style={{flex: 1, textAlign: 'center'}}>Enviar mensaje</span>
                <div style={{width: '20px', height: '20px'}}></div>
                </button>
              </div>
            </div>
          )}
          {isInitialLoad && (
            <p className="info-message">¡Ya estoy registrado! Mis datos no pueden ser modificados desde aquí.</p>
          )}
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="registration-form">
          <h3 className='mb-5' style={{marginTop: '20px'}}>
            <img 
              src={require('../images/huellitanegra.jpg')} 
              alt="" 
              width="32" 
              height="32" 
              style={{marginRight: '8px', verticalAlign: 'middle'}}
            />
            ¡Registro!
          </h3>
          
          {/* Sección 1: Datos de tu mascota */}
          <div className="form-section">
            <h4 className="section-title">Datos de tu mascota</h4>
            
            <div className="form-group">
              <label htmlFor="nombreMascota">Nombre de la mascota:</label>
              <input
                type="text"
                id="nombreMascota"
                name="nombreMascota"
                value={formData.nombreMascota}
                onChange={handleChange}
                placeholder="Rocky, Lola, Michi..."
                required
              />
            </div>


          </div>

          {/* Sección 2: Datos del responsable */}
          <div className="form-section">
            <h4 className="section-title">Datos del responsable</h4>
            
            <div className="form-group">
              <label htmlFor="nombrePropietario">Tu nombre:</label>
              <input
                type="text"
                id="nombrePropietario"
                name="nombrePropietario"
                value={formData.nombrePropietario}
                onChange={handleChange}
                placeholder="María, Juan..."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="apellidoPropietario">Tu apellido:</label>
              <input
                type="text"
                id="apellidoPropietario"
                name="apellidoPropietario"
                value={formData.apellidoPropietario}
                onChange={handleChange}
                placeholder="García, Pérez..."
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="telefono">Teléfono:</label>
              <input
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="123456789"
                required
              />
            </div>

            <div className="form-group checkbox-group">
              <label htmlFor="tieneWhatsapp" className="checkbox-label">
                <input
                  type="checkbox"
                  id="tieneWhatsapp"
                  name="tieneWhatsapp"
                  checked={formData.tieneWhatsapp}
                  onChange={handleChange}
                />
                <span className="checkmark"></span>
                Este número tiene WhatsApp
              </label>
            </div>

            <div className="form-group">
              <label htmlFor="direccion">Dirección:</label>
              <input
                type="text"
                id="direccion"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                placeholder="Calle 123, Ciudad"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="juan.perez@email.com"
                required
              />
            </div>
          </div>

          <div style={{textAlign: 'center', marginTop: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
              <button 
                type="submit" 
                className="submit-button"
                style={{
                  width: '100%',
                  maxWidth: '300px',
                  alignSelf: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  marginTop: '0'
                }}
              >
                ¡Registrarme!
              </button>
            </div>
          </div>
        </form>
      )}

      {submissionStatus === 'success' && (
        <p className="success-message">¡Registro exitoso! Sus datos han sido guardados.</p>
      )}
      {submissionStatus === 'error' && (
        <p className="error-message">Error en el registro. Por favor, intente de nuevo.</p>
      )}
    </div>
  );
};

export default TagPage;
